// Cơ quan ban hành
import { makeAutoObservable } from 'mobx'
// Request
import { AuthorityRequest } from '../requests/AuthorityRequest'
import { DOCUMENT_TYPE } from '../constants'

class AuthorityStore {
  /** Authority Issueds */
  authorityIssuedsList = []

  authorityIssuedsQueryParams = {
    type: DOCUMENT_TYPE.INCOMING,
    key: null,
  }

  constructor() {
    makeAutoObservable(this)
  }

  setAuthorityIssuedsQueryParams = payload => {
    this.authorityIssuedsQueryParams = payload
  }

  getAuthorityIssueds = () => {
    return new Promise((resolve, reject) => {
      AuthorityRequest.getAuthorityIssueds(this.authorityIssuedsQueryParams)
        .then(response => {
          this.authorityIssuedsList = response.data
          this.authorityIssuedsListOrigin = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createAuthority = payload => {
    return new Promise((resolve, reject) => {
      AuthorityRequest.createAuthority(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new AuthorityStore()
